<template>
  <div class="main">
    <div>
      <el-table :data="tableData" border style="width: 100%" v-loading="loading">
        <el-table-column prop="cellName" align="center" label="表头名称" width="130"></el-table-column>
        <el-table-column label="错误行数" align="center" width="130">
          <template slot-scope="scope">第 {{scope.row.row+1}} 行</template>
        </el-table-column>
        <el-table-column prop="errorInfo" align="center" label="异常信息"></el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        :page-size="10"
        :total="pageTotal"
        :current-page="page"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  // import { analysisExceptions, getExcData } from '@/api/data'

  import HttpRequest from '../../../utils/axios';
  import {baseUrl} from '../../../utils/constant';

  export default {
    name: 'exceptionLog',
    props: {id: String},
    data() {
      return {
        tableData: [],
        page: 1,
        pageTotal: null,
        loading: true
      }
    },
    watch: {
      id: function (id) {
        this.getEx()
      }
    },
    methods: {
      getEx() {
        // let id = this.$route.query.id
        const apiName = process.env.BUILD_ENV === 'dev' ? '' : ''
        new HttpRequest(baseUrl).request({
          method: 'get',
          url: `${baseUrl}${apiName}ec-new-product-file-api/file/analysisExceptions?taskId=` + this.id
        }).then(res => {
          // 错误总数
          this.pageTotal = res.data.data.total
          this.tableData = res.data.data.dataList
          this.loading = false
        })
      },
      // 翻页
      handleCurrentChange(val) {
        this.currentPage = val
        const apiName = process.env.BUILD_ENV === 'dev' ? '' : ''
        new HttpRequest(baseUrl).request({
          method: 'get',
          url: `${baseUrl}${apiName}ec-new-product-file-api/file/analysisExceptions?taskId=` + this.id + '&&pageNum=' + this.currentPage
        }).then(res => {
          this.pageTotal = res.data.data.total
          this.tableData = res.data.data.dataList
          this.loading = false
        })
      }
    },
    mounted() {
      this.getEx()
    }
  }
</script>

<style lang="stylus" scoped>
  .pagination
    margin-top 20px
    text-align right
</style>
